var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Ad, Member, Offer, Link } from 'aigens-ng-core';
import { Injector, OnInit, ChangeDetectorRef } from '@angular/core';
import { MobileBasePage } from '../../../../core/base/mobile-base-page';
import { isAvailableOffer } from '../../../../shared/utilities/checkFormatTool';
import { RewardListDialog } from '../../../../dialogs/reward-list/reward-list';
/*
  Generated class for the Home page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
var MemberRewardCourtPage = /** @class */ (function (_super) {
    __extends(MemberRewardCourtPage, _super);
    function MemberRewardCourtPage(injector, cd) {
        var _this = _super.call(this, injector) || this;
        _this.injector = injector;
        _this.cd = cd;
        _this.ads = [];
        _this.offers = [];
        _this.startPoint = 0;
        _this.endPoint = 380;
        _this.qaOpened = false;
        _this.numStart = 0;
        _this.numEnd = 380;
        _this.count = _this.numStart;
        _this.increment = 10;
        _this.pointFeature = false;
        _this.pointsToUse = null;
        _this.isBounce = false;
        _this.badgeNum = 0;
        _this.enableStamps = false;
        _this.totalStamps = [];
        _this.stamps = 0;
        _this.totalStampsCount = 10;
        _this.sagmentValue = 'reward';
        _this.initTotalStamps();
        var brand = _this.getNavParams('brand');
        _this.ads = brand && brand.ads.filter(function (ad) { return ad.type !== 'popup'; });
        _this.hasCrmId = !!brand['crmId'];
        if (_this.memberService.offers) {
            _this.offers = _this.memberService.offers;
        }
        _this.getApi(brand);
        // const store_ = this.orderService.store;
        _this.pointFeature = brand && brand['crm'] && brand['crm']['addPoints'] || false;
        _this.enableStamps = brand && brand['crm'] && brand['crm']['addStamps'] || false;
        _this.brand = brand;
        _this.sagmentValueInit();
        return _this;
    }
    MemberRewardCourtPage.prototype.sagmentValueInit = function () {
        if (this.offers.length > 0) {
            this.sagmentValue = 'reward';
        }
        else if (this.enableStamps) {
            this.sagmentValue = 'stamps';
        }
        else if (this.enableStamps) {
            this.sagmentValue = 'promotion';
        }
    };
    MemberRewardCourtPage.prototype.segmentChanged = function (ev) {
        console.log('Segment changed', ev);
        this.sagmentValue = ev.detail.value;
        this.cd.detectChanges();
    };
    MemberRewardCourtPage.prototype.getApi = function (brand) {
        var _this = this;
        this.loading(true);
        Promise.all([this.getMember(brand), this.getCourtReward()]).then(function (resluts) {
            _this.loading(false);
            if (!resluts) {
                return;
            }
            /// update  this.configService.getMember()
            var member = _this.memberService.getMember();
            var memberships = resluts[0];
            var has = (memberships && memberships instanceof Array && memberships.length > 0);
            if (has) {
                member.membership = memberships[0];
                _this.updateStamps(member.membership['stamps']);
            }
            // this.member = member;
            if (_this.memberService.member && _this.pointFeature) {
                _this.numEnd = _this.memberService.member.membership && _this.memberService.member.membership.usablePoints ? _this.memberService.member.membership.usablePoints : 0;
                // this.numEnd = 6009; //9990909901
                _this.increment = _this.numEnd;
                var time = 10;
                while (_this.increment / 10 > 1) {
                    time = time * 10;
                    _this.increment = _this.increment / 10;
                }
                var countFactor = _this.increment > 7 ? 5 : (_this.increment > 5 ? 2 : 1);
                _this.increment = time * countFactor / 100;
                /// fixed ,等html 加載完成,否則document.getElementById('point') 可能為 null
                setTimeout(function () {
                    _this.displayLoop();
                }, 500);
            }
            var offers = resluts[1];
            if (offers instanceof Array) {
                _this.offers = offers;
                _this.memberService.offers = _this.offers;
            }
        }).catch(function (err) {
            _this.loading(false);
            if (err && err.status && err.status === 401) {
                _this.showAlert(err.status, err['_body'], [{
                        text: _this.t.instant('buttons.ok'),
                        handler: function () {
                            _this.memberService.clear();
                            _this.navigationService.popToRoot();
                        }
                    }]);
            }
            else {
                _this.showError(err);
            }
        });
    };
    MemberRewardCourtPage.prototype.logout = function () {
        var _this = this;
        this.showAlert('', this.t.instant('pages.profile.alert-title'), [{
                text: this.t.instant('buttons.no'),
                handler: function () {
                    console.log('cancel');
                }
            }, {
                text: this.t.instant('buttons.yes'),
                handler: function () {
                    _this.memberService.clear();
                    _this.orderService.logoutClear();
                    _this.popToRoot();
                }
            }]);
    };
    MemberRewardCourtPage.prototype.backButtonClick = function () {
        this.navigationService.popToRoot();
    };
    // 由于html模板里无法直接使用Import进来的方法，这里包装一下。或者使用继承MobileBasePage
    MemberRewardCourtPage.prototype.isAvailableReward = function (offer) {
        return isAvailableOffer(offer);
    };
    MemberRewardCourtPage.prototype.displayLoop = function () {
        var _this = this;
        var temp = document.getElementById('point');
        if (temp) {
            document.getElementById('point').innerHTML = "<span>" + this.count + "</span>";
        }
        if (this.count < this.numEnd) {
            this.loop = setTimeout(function () {
                _this.displayLoop();
            }, 30);
            if (this.increment > 0 && this.numEnd - this.count > this.increment) {
                this.count += this.increment;
            }
            else {
                this.count++;
            }
        }
    };
    MemberRewardCourtPage.prototype.ngOnInit = function () {
        console.log('ngOnInit HomePage');
        // this.displayLoop();
    };
    MemberRewardCourtPage.prototype.redeem = function (i) {
        // if(i === 0 && this.orderService.redeemedReward.length <= 0){
        // this.showAlert("Do you want to redeem?","",[{
        //     text: "No",
        //     handler: () => {
        //     }
        // },{
        //     text: "Yes",
        //     handler: () => {
        //             this.orderService.redeemedReward.push(this.orderService.rewards[i]);
        //             this.orderService.rewards.splice(i,1);
        //             this.badgeNum ++;
        //             this.isBounce = true;
        //             setTimeout(()=>{this.isBounce=false;},800);
        //         }
        //     }]);
        // }
    };
    MemberRewardCourtPage.prototype.goProfile = function () {
        this.pushByName('ProfileCourtPage', { isEditMode: false });
    };
    MemberRewardCourtPage.prototype.openRewardList = function (offer) {
        this.pushByName('RewardListPage', { offer: offer });
    };
    MemberRewardCourtPage.prototype.qaBoxEvent = function () {
        this.qaOpened = !this.qaOpened;
        console.log(this.qaOpened);
    };
    MemberRewardCourtPage.prototype.redeemReward = function (offer) {
        if (isAvailableOffer(offer)) {
            if (!this.orderService.spot && this.selectOrderModeAlert(offer)) {
                return;
            }
            this.pushToNext(offer);
        }
    };
    MemberRewardCourtPage.prototype.startOrder = function () {
        if (!this.orderService.spot && this.selectOrderModeAlert()) {
            return;
        }
        this.pushToNext();
    };
    MemberRewardCourtPage.prototype.selectOrderModeAlert = function (offer) {
        if (this.orderManager.mode === 'preorder' || this.orderManager.mode === 'dinein' || this.orderManager.mode === 'takeaway') {
            console.log('no need to select mode');
            return false;
        }
        // TODO: check court mode?
        if (!this.orderManager.store) {
            console.warn('no store', this.orderManager);
            return false;
        }
        if (!this.isPopupModeSelectModalAccordingToStoreMenuMode(this.orderManager.store)) {
            return false;
        }
        var alert = this.showModeAlert(offer);
        alert.then(function (a) { return a.present(); });
        return true;
    };
    MemberRewardCourtPage.prototype.showModeAlert = function (offer) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.alertController.create({
                            header: this.t.instant('pages.splash.prompt-dine-mode'),
                            backdropDismiss: false,
                            buttons: [
                                {
                                    text: this.t.instant('pages.splash.dine-in'),
                                    handler: function () {
                                        // to do
                                        // this.googleAnalyticEventTrack()
                                        _this.orderManager.mode = 'dinein';
                                        _this.pushToNext(offer);
                                    }
                                },
                                {
                                    text: this.t.instant('pages.splash.takeout'),
                                    handler: function () {
                                        // to do
                                        // this.googleAnalyticEventTrack();
                                        _this.orderManager.mode = 'takeaway';
                                        _this.pushToNext(offer);
                                    }
                                }
                            ]
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MemberRewardCourtPage.prototype.goToPromotion = function (ad) {
        if (ad['links'] && (ad['links']['default'] || ad['links']['app'])) {
            this.pushByName('PromotionDetailPage', { ad: ad });
        }
    };
    MemberRewardCourtPage.prototype.initTotalStamps = function () {
        // default = 10;
        var tmps = [];
        for (var i = 0; i < this.totalStampsCount; i++) {
            var stamp = { active: false, index: i, showNumber: i + 1 };
            tmps.push(stamp);
        }
        this.totalStamps = tmps;
    };
    MemberRewardCourtPage.prototype.updateStamps = function (stampCount) {
        if (isNaN(stampCount)) {
            return;
        }
        var limit = Math.min(stampCount, this.totalStamps.length);
        for (var i = 0; i < limit; i++) {
            this.totalStamps[i]['active'] = true;
        }
    };
    MemberRewardCourtPage.prototype.handleEffectiveStamp = function (effectiveCount) {
        if (isNaN(effectiveCount)) {
            return;
        }
        this.stamps = effectiveCount;
        var count = Number(effectiveCount);
        this.totalStamps.forEach(function (s) {
            var showNumber = Number(s.showNumber);
            // reset
            s.active = false;
            if (showNumber <= count) {
                s.active = true;
            }
        });
    };
    MemberRewardCourtPage.prototype.clickedStamp = function (stamp, index) {
        console.log('stamp index', stamp, index);
        var number = index + 1;
        // if (stamp.active && number == 5) {
        //     console.log("clicked 5..");
        // }
    };
    MemberRewardCourtPage.prototype.clickedRedeem = function (stamp) {
    };
    MemberRewardCourtPage.prototype.onRewardListClick = function () {
        var _this = this;
        this.memberApiService.getRedeemableRewards(this.brand.id).subscribe(function (rewards) {
            var input = { rewards: rewards };
            // TODO: enter animation using animated or enterAnimation?
            _this.modalController.create({
                component: RewardListDialog,
                componentProps: input,
                showBackdrop: true,
                backdropDismiss: true,
                cssClass: 'modal-largescreen',
                animated: true
            }).then(function (modal) {
                modal.onWillDismiss().then(function (reward) {
                    // TODO: is this
                    console.log('reward', reward);
                    if (reward) {
                        _this.memberApiService.redeemReward(_this.orderManager.store.brandId, reward.data.id).subscribe(function (data) {
                            console.log('reward redeemed', data);
                            _this.getApi(_this.orderManager.store);
                        });
                    }
                    else {
                        console.log('no reward redeemed');
                    }
                });
                modal.present();
            });
        });
    };
    MemberRewardCourtPage.prototype.getCourtReward = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.orderService.getCourtReward().subscribe(function (offers) {
                resolve(offers);
            }, function (err) {
                console.log('getReward error', err);
                reject(err);
            });
        });
    };
    MemberRewardCourtPage.prototype.getTandCUrl = function (brand, name) {
        if (!brand.links) {
            return null;
        }
        var link = brand.links[name];
        if (!link) {
            return null;
        }
        var url = link.url;
        if (!url) {
            return null;
        }
        if (url.indexOf('http://') === 0 && url.indexOf('localhost') === -1) {
            url = url.replace('http:', 'https:');
        }
        return url;
    };
    MemberRewardCourtPage.prototype.getMember = function (brand) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.memberApiService.checkingMembership(brand.id).subscribe(function (memberships) { return __awaiter(_this, void 0, void 0, function () {
                var url, isFb, handler;
                var _this = this;
                return __generator(this, function (_a) {
                    console.log('calling membership', memberships, this.memberService.member);
                    resolve(memberships);
                    if (!memberships || memberships.length === 0) {
                        url = this.getTandCUrl(brand, 'byodTc');
                        isFb = false;
                        handler = function (handle) {
                            if (handle['fail'] === 'failed') {
                                _this.memberService.clear();
                                _this.navigationService.popToRoot();
                            }
                            else {
                                // do membership here
                                var marketing = false;
                                marketing = handle['marketing'];
                                var marketingOrderPlace = false;
                                marketingOrderPlace = handle['marketingBrand'];
                                _this.loading(true);
                                _this.memberApiService.join(null, _this.brand.id, marketing).subscribe(function (result) {
                                    _this.loading(false);
                                }, function (err) {
                                    _this.loading(false);
                                });
                            }
                        };
                        // if (this.memberService.member['source'] === "ascentis") {
                        //     return
                        // }
                        // if (url) {
                        //     const params = { url: url, needToAgreeMarketing: true };
                        //     if (isFb) { // isFb=false
                        //         params['fbHandler'] = handler;
                        //     }
                        //     params['brandName'] = brand.name;
                        //     const modal = await this.modalController.create({ component: TermsConditionsPage, componentProps: params, backdropDismiss: false });
                        //     modal.onDidDismiss().then((result) => {
                        //         console.log('tnc result', result.data);
                        //         if (result && handler && !isFb) {
                        //             handler(result.data);
                        //         }
                        //     });
                        //     modal.present();
                        // } else {
                        //     console.warn('Please add Terms and Conditions');
                        //     this.loading(false);
                        //     this.showAlert(this.t.instant('pages.base.missing-tnc'), '');
                        // }
                    }
                    return [2 /*return*/];
                });
            }); }, function (err) {
                console.log('checkingMembership error', err);
                reject(err);
            });
        });
    };
    MemberRewardCourtPage.prototype.pushToNext = function (offer) {
        var _this = this;
        this.menuManager.clearAvailableMap();
        // TODO: use this as default layout?
        // call general start order function here
        // i.e set up order manager, settings, etc.
        // this.initOrder();
        this.pushAndRemovePage('BrandStoreListPage', {
            courtId: this.brand.id
        }, null, function () {
            if (offer) {
                _this.clickReward(offer, _this.orderManager.store, 'ItemGridPage');
            }
        });
    };
    return MemberRewardCourtPage;
}(MobileBasePage));
export { MemberRewardCourtPage };
